import React from 'react';
import { motion } from 'framer-motion';
import { Fuel } from 'lucide-react';

const LoadingScreen = ({ message = 'Initializing Fuel Monitor System...' }) => {
  return (
    <div className="fixed inset-0 z-50 bg-surface-950">
      {/* Background Gradient */}
      <div className="absolute inset-0 bg-gradient-to-br from-primary-500/10 via-transparent to-primary-500/5" />
      
      {/* Grid Pattern */}
      <div className="absolute inset-0 opacity-5">
        <svg width="100%" height="100%">
          <defs>
            <pattern id="grid" width="40" height="40" patternUnits="userSpaceOnUse">
              <path d="M 40 0 L 0 0 0 40" fill="none" stroke="white" strokeWidth="0.5" />
            </pattern>
          </defs>
          <rect width="100%" height="100%" fill="url(#grid)" />
        </svg>
      </div>

      <div className="relative h-full flex items-center justify-center">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          className="text-center"
        >

          {/* Title */}
          <h1 className="text-3xl font-bold text-white mb-2">
            FUEL<span className="text-primary-400">MONITOR</span>
          </h1>
          <p className="text-sm text-surface-400 mb-8">{message}</p>

          {/* Progress Bar */}
          <div className="w-64 mx-auto">
            <div className="h-1 bg-surface-700 rounded-full overflow-hidden">
              <motion.div
                initial={{ width: '0%' }}
                animate={{ width: '100%' }}
                transition={{ duration: 2, repeat: Infinity, ease: 'easeInOut' }}
                className="h-full bg-gradient-to-r from-primary-500 to-primary-400"
              />
            </div>
          </div>

          {/* Loading Dots */}
          <div className="flex justify-center gap-2 mt-6">
            {[0, 1, 2].map((i) => (
              <motion.div
                key={i}
                animate={{ y: [0, -8, 0], opacity: [0.3, 1, 0.3] }}
                transition={{ duration: 0.8, repeat: Infinity, delay: i * 0.15 }}
                className="w-2 h-2 bg-primary-400 rounded-full"
              />
            ))}
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default LoadingScreen;